module.exports = __webpack_public_path__ + "img/11_uk.448b925d.svg";